import { GetListResponse } from "@app/types";
import { CreateSqlTemplateRequest, ExecuteSqlTemplateRequest, ExecuteSqlTemplateResponse, SqlTemplate, UpdateSqlTemplateRequest } from "@app/types/sql-templates.type";
import HttpService from "@core/services/http/http.service";
import {
  RequestParams,
  Signal,
} from "@core/services/http/http.type";

class _SqlTemplatesService {
  public getList(requestParams?: RequestParams, signal?: Signal) {
    return HttpService.get<GetListResponse<SqlTemplate>>(
      "/admin/api/v3/sql-templates",
      {
        queryParams: { ...requestParams },
        signal,
      }
    );
  }

  public create(createSqlTemplateRequest: CreateSqlTemplateRequest) {
    return HttpService.post("/admin/api/v3/sql-templates", {
      body: { ...createSqlTemplateRequest }
    });
  }

  public update(
    sqlTemplateId: number,
    updateSqlTemplateRequest: UpdateSqlTemplateRequest
  ) {
    return HttpService.put(`/admin/api/v3/sql-templates/${sqlTemplateId}`, {
      body: { ...updateSqlTemplateRequest }
    });
  }

  public delete(sqlTemplateId: number) {
    return HttpService.delete(`/admin/api/v3/sql-templates/${sqlTemplateId}`);
  }

  public execute(executeSqlTemplateRequest: ExecuteSqlTemplateRequest) {
    return HttpService.post<GetListResponse<ExecuteSqlTemplateResponse>>("/admin/api/v3/sql-templates/execute", {
      body: { ...executeSqlTemplateRequest }
    });
  }
}

const SqlTemplatesService = new _SqlTemplatesService();

export default SqlTemplatesService;
